import { index, integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { syncedColumns } from './common';

/**
 * Synced. The shopping list (spec §6). An item stays until it is bought (tripId set) or removed
 * (soft delete); the open list is tripId IS NULL. Export record type "Shopping list" (v0.6).
 */
export const shoppingItems = sqliteTable(
  'shopping_items',
  {
    ...syncedColumns(),
    name: text('name').notNull(),
    quantity: real('quantity'),
    unit: text('unit'),
    /** Centavos for the whole line (quantity included). */
    estimateMinor: integer('estimate_minor'),
    currency: text('currency').notNull().default('PHP'),
    store: text('store'),
    position: real('position').notNull().default(0),
    /** The trip it was bought on; null while it is on the open list. */
    tripId: text('trip_id'),
  },
  (t) => [index('shopping_items_user_idx').on(t.userId)],
);

/**
 * Synced. One purchase: date, store, the total paid and the Spending expense it logged (null when
 * Spending was off). Never overwritten; deletes are soft and go through History. Export record
 * type "Shopping trips" (v0.6).
 */
export const shoppingTrips = sqliteTable(
  'shopping_trips',
  {
    ...syncedColumns(),
    /** Local calendar day 'YYYY-MM-DD'. */
    date: text('date').notNull(),
    store: text('store'),
    totalMinor: integer('total_minor').notNull(),
    currency: text('currency').notNull().default('PHP'),
    expenseId: text('expense_id'),
  },
  (t) => [index('shopping_trips_user_date_idx').on(t.userId, t.date)],
);

/**
 * Synced. One line of a trip. A line with a price is a price point (item, normalized name,
 * quantity/unit, price; store and date come from the trip). Export record type "Item prices" (v0.6).
 */
export const shoppingTripItems = sqliteTable(
  'shopping_trip_items',
  {
    ...syncedColumns(),
    tripId: text('trip_id').notNull(),
    /** The list item it came from. */
    itemId: text('item_id'),
    name: text('name').notNull(),
    /** normalizeNote(name): lowercase ASCII words, so "Rice" and "rice " compare as one item. */
    normalizedName: text('normalized_name').notNull(),
    quantity: real('quantity'),
    unit: text('unit'),
    /** What this line cost in centavos; null when only the trip total is known. */
    priceMinor: integer('price_minor'),
    position: real('position').notNull().default(0),
  },
  (t) => [
    index('shopping_trip_items_user_trip_idx').on(t.userId, t.tripId),
    index('shopping_trip_items_user_name_idx').on(t.userId, t.normalizedName),
  ],
);
